<template>
<div class="menuBody" >
    <BillManTree @AllData="getMsgFormSon" @NodeData="NodeData"  />
        <BillsDepartmenDialog :param="diaLogData" @Visible="Visible" ref="BillsDepartmenDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                票据管理部门列表  
            </div>
             <div style="width:200px;float:left;margin-right:30px">
                 <el-input placeholder="请输入票据管理部门名称" size="small"     v-model="groupName"></el-input>
            </div>
             <div style="float:left;">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:bs:bmDs:selectListPage'" @click="Inquire()">查询</el-button>
            </div>
            <div style="float:right;margin-top:-5px;margin-right:10px">
                <el-button type="primary" v-show="this.mangroupId !='' "  size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:bs:bmDs:save'" @click="PropertyAdd()">票据管理部门添加</el-button>
            </div>
              <el-table tooltip-effect="light"   :data="tableData" v-loading="loading"   style="overflow-y: scroll;float:right;margin-top:30px" 
        row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column prop="officeName" show-overflow-tooltip label="票据管理部门"  ></el-table-column>
      <el-table-column prop="createDate" show-overflow-tooltip label="创建时间" ></el-table-column>
        <el-table-column prop="updateDate" show-overflow-tooltip label="更新时间" ></el-table-column>
      <el-table-column prop="remarks" show-overflow-tooltip label="备注" ></el-table-column>
    <el-table-column fixed="right" label="操作" >
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" v-Jurisdiction="'expense:web:bs:bmDs:save'" circle size="small" title="修改"></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" v-Jurisdiction="'expense:web:bs:bmDs:delete'" circle size="small" title="删除"  v-debounce></el-button>
        </template>
    </el-table-column>
  </el-table>
        <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import BillsDepartmenDialog from "../common/BillsDepartmenDialog";
import BillManTree from "../common/BillManTree.vue";

export default {
  name: "BillsDepartmen",
  components: {BillsDepartmenDialog,BillManTree},
  data() {
    return {
      loading:false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        groupNum:"",
        groupName:"",
        UpCourseCode:"",
        amount:[],
        amountval:"",
      tableData: [],
      options: [{
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }],
        value: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      USERObj:"",
      ProjectMana:"",
      taxRateval:"",
      taxRatelab:"",
      mangroupId:"",
    }
  },
  methods: {
    handleSelectionChange(val){
      this.USERObj= val
    },
    getMsgFormSon(data){
      this.AllData = data
    },
    SharList(){
       let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "mangroupId":this.mangroupId,
      }
        this.$http.post(this.$requestUrl.POST_BILL_DEPARTLIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    NodeData(data){
      this.loading = true
        this.mangroupId = data.value
        this.mangrouplab = data.label
        this.SharList()
    },
    handleSizeChange(val) {
        this.pagesize = val
        this.SharList()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.SharList()
    },
    Inquire(){
    let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "officeName":this.groupName,
        "mangroupId":this.mangroupId,
      }
        this.$http.post(this.$requestUrl.POST_BILL_DEPARTLIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.tableData = data.data.records;
            this.groupName = ""
          } else {
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      
    },
    PropertyAdd(){
        // 添加项目
        if(this.USERObj.length == 0){
      this.$refs.BillsDepartmenDialog.title = "添加";
      this.$refs.BillsDepartmenDialog.dialogVisible = true; 
      this.$refs.BillsDepartmenDialog.options = this.AllData;
          let obj = {
            "department":"票据组归属部门",
            "mangroupName":"票据管理组",
            "remarks":"备注信息",
          }
          let row = {}
          row.obj = obj
          this.$refs.BillsDepartmenDialog.value = ""
            this.$refs.BillsDepartmenDialog.valueone = ""
         this.$refs.BillsDepartmenDialog.formLabelAlign= row;
        }
    },
    editMenu(row) { // 修改
    let arr = []
    let list = {}
    list.officeId = row.officeId
    list.officeName = row.officeName
    arr.push(list)
    let array = []
    array.push(list.officeId)
      this.$refs.BillsDepartmenDialog.title = "修改";
      this.$refs.BillsDepartmenDialog.dialogVisible = true;
      this.$refs.BillsDepartmenDialog.options = this.AllData;
      this.$refs.BillsDepartmenDialog.value = row.mangroupId
      this.$refs.BillsDepartmenDialog.optionsone = arr
      this.$refs.BillsDepartmenDialog.valueone = array
        let obj = {
           "department":"票据组归属部门",
          "mangroupName":"票据管理组",
          "remarks":"备注信息",
          }
        row.obj = obj
         this.$refs.BillsDepartmenDialog.formLabelAlign= row;
        },
    delMenu(row){
      this.$confirm('是否确认要删除该部门?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
      this.$http.post(this.$requestUrl.DELETE_BILL_DEPART+"?id="+row.id).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.SharList()
             this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }else{
           this.$message({
            type: 'warning',
            message: '删除失败'
          });
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
   Visible(data){
      if(data == false){
        this.loading = true
        this.SharList();
      }
    }

  },
  mounted() {
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>